import { isJust, toMaybe, type Maybe } from "../lib/maybe";
import {
  isProjectAssetReference,
  projectAssetPreviewSrc,
} from "../lib/projectAssets";
import { livePreviewImageBasePath } from "../lib/tauri/assets";

/** `.zwdoc` image `src` → URL the webview can load. */
export function resolveImagePreviewSrc(
  imageSrc: string,
  storageRoot: Maybe<string>,
  tick: number,
): string {
  const src = imageSrc.trim();
  if (src.length === 0) return "";
  if (isProjectAssetReference(src) && isJust(storageRoot)) {
    return projectAssetPreviewSrc(storageRoot.value, src, tick);
  }
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(src) || src.startsWith("/")) {
    return src;
  }
  if (isJust(storageRoot)) {
    const base = toMaybe(livePreviewImageBasePath(storageRoot.value));
    if (isJust(base) && base.value.length > 0) {
      try {
        return new URL(
          src,
          base.value.endsWith("/") ? base.value : `${base.value}/`,
        ).toString();
      } catch {
        return projectAssetPreviewSrc(storageRoot.value, src, tick);
      }
    }
  }
  return src;
}
